export enum AppStatus {
  uninitialized = 'uninitialized',
  initialized = 'initialized',
  initializing = 'initializing',
  failedInitialization = 'failed Initialization',
}
